import { render } from "./BrowserPlugins.vue.js?vue&type=template&id=e12b7170!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrowserPlugins.vue?vue&type=template&id=e12b7170"
import script from "./BrowserPlugins.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrowserPlugins.vue?vue&type=script&lang=js"
export * from "./BrowserPlugins.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrowserPlugins.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/monetization/BrowserPlugins.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e12b7170"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e12b7170', __exports__)) {
    api.reload('e12b7170', __exports__)
  }
  
  module.hot.accept("./BrowserPlugins.vue.js?vue&type=template&id=e12b7170!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrowserPlugins.vue?vue&type=template&id=e12b7170", () => {
    api.rerender('e12b7170', render)
  })

}


export default __exports__